"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tSuccess = exports.tInfo = exports.tError = exports.default = exports.dSuccess = exports.dError = exports.dConfirm = exports.ToastContainer = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactHotToast = require("react-hot-toast");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _sweetalert2ReactContent = _interopRequireDefault(require("sweetalert2-react-content"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var ReSwal = (0, _sweetalert2ReactContent.default)(_sweetalert.default);
function _dOption(icon, d) {
  var customClass = {
    container: 'dialog-container',
    popup: '_popup',
    icon: '_icon',
    title: '_title',
    htmlContainer: '_detail',
    actions: '_actions'
  };
  if (typeof d === 'string') return {
    icon: icon,
    customClass: customClass,
    title: d
  };
  if (_typeof(d) === 'object' && !!d.title) return _objectSpread(_objectSpread({
    icon: icon,
    customClass: customClass
  }, d), {}, {
    title: d.title,
    html: !d.detail ? undefined : d.detail
  });
}
var dSuccess = function dSuccess(data) {
  return ReSwal.fire(_dOption((data === null || data === void 0 ? void 0 : data.icon) || 'success', data));
};
exports.dSuccess = dSuccess;
var dConfirm = function dConfirm(data) {
  var title = typeof data === 'string' ? {
    title: data
  } : data;
  var options = _dOption(data.icon || 'warning', _objectSpread(_objectSpread({}, title), {}, {
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel'
  }));
  return new Promise(function (resolve, reject) {
    return ReSwal.fire(options).then(function (result) {
      return !!result.value ? resolve(result.value) : reject(false);
    });
  });
};
exports.dConfirm = dConfirm;
var dError = function dError(data, callback) {
  ReSwal.fire(_dOption('error', (data === null || data === void 0 ? void 0 : data.error) || data)).then(function () {
    if (callback) callback();
  });
};

// -----
exports.dError = dError;
var ToastDetail = function ToastDetail(props) {
  var data = props.data;
  if (data.errors !== undefined && Array.isArray(data.errors)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "toast-detail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "_head"
    }, props.title ? props.title : 'Error!'), /*#__PURE__*/React.createElement("div", {
      className: "_detail"
    }, /*#__PURE__*/React.createElement("ul", null, data.errors.map(function (d, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: "t_".concat(i)
      }, d);
    }))));
  }
  if (_typeof(data) === 'object') {
    if (Array.isArray(data)) {
      return /*#__PURE__*/React.createElement("ul", null, data.map(function (d, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: "t_".concat(i)
        }, d);
      }));
    }
    var title = (0, _utils.test)(data.title, data.header, false);
    var detail = (0, _utils.test)(data.detail, data.text, false);
    return /*#__PURE__*/React.createElement("div", {
      className: "toast-detail"
    }, !!title && /*#__PURE__*/React.createElement("div", {
      className: "_head"
    }, title), !!detail && /*#__PURE__*/React.createElement("div", {
      className: "_detail"
    }, Array.isArray(detail) ? detail.map(function (d, i) {
      return /*#__PURE__*/React.createElement("li", {
        key: "t_".concat(i)
      }, d);
    }) : detail));
  }
  return /*#__PURE__*/React.createElement("span", null, "?");
};
var tSuccess = function tSuccess(d, option) {
  return _reactHotToast.toast.success(typeof d === 'string' ? d : function () {
    return /*#__PURE__*/React.createElement(ToastDetail, {
      data: d
    });
  }, option);
};
exports.tSuccess = tSuccess;
var tError = function tError(d, d2) {
  if (typeof d === 'string') return _reactHotToast.toast.error(d);
  if (d.error !== undefined && typeof d.error === 'string') return _reactHotToast.toast.error(d.error);
  if (d.errors !== undefined && Array.isArray(d.errors) && d.errors.length === 1) return _reactHotToast.toast.error(d.errors[0]);
  return _reactHotToast.toast.error(function () {
    return /*#__PURE__*/React.createElement(ToastDetail, {
      data: d,
      title: d2
    });
  });
};
exports.tError = tError;
var tInfo = function tInfo(d, option) {
  return (0, _reactHotToast.toast)(typeof d === 'string' ? d : function () {
    return /*#__PURE__*/React.createElement(ToastDetail, {
      data: d
    });
  }, option);
};
exports.tInfo = tInfo;
var ToastContainer = function ToastContainer() {
  return /*#__PURE__*/React.createElement(_reactHotToast.Toaster, {
    position: 'top-center',
    toastOptions: {
      className: 'un-toast-container'
    }
  });
};
exports.ToastContainer = ToastContainer;
var _default = {
  dConfirm: dConfirm,
  dSuccess: dSuccess,
  dError: dError,
  tSuccess: tSuccess,
  tError: tError,
  tInfo: tInfo
};
exports.default = _default;